"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("app-select", {
    attrs: {
      label: "Selecione a Área",
      placeholder: "Área",
      items: _vm.allPlots,
      option: "id",
      "name-item": "name",
      expanded: ""
    },
    model: {
      value: _vm.selectedPlot,
      callback: function callback($$v) {
        _vm.selectedPlot = $$v;
      },
      expression: "selectedPlot"
    }
  }), _vm._v(" "), _vm.selectedPlot && _vm.subplots.length > 0 ? _c("app-select", {
    attrs: {
      label: "Selecione a Sub-área",
      placeholder: "Sub-área",
      items: _vm.subplots,
      option: "id",
      "name-item": "name",
      expanded: ""
    },
    model: {
      value: _vm.selectedSubplot,
      callback: function callback($$v) {
        _vm.selectedSubplot = $$v;
      },
      expression: "selectedSubplot"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;